import React, { createContext, useContext, useMemo, useState } from 'react';

interface AppContextType {
	loading: boolean;
	error: boolean;
	errorLog?: string;
	success: boolean;
	thankyouScreen?: React.ReactElement;
	setAppLoading: (loading: boolean) => void;
	setAppError: (error: boolean) => void;
	setAppErrorLog: (log: string) => void;
	setAppSuccess: (success: boolean) => void;
	setAppThankyouScreen: (screen: React.ReactElement) => void;
}

const AppContext = createContext<AppContextType | null>(null);

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [errorLog, setErrorLog] = useState<string>();
	const [success, setSuccess] = useState(false);
	const [thankyouScreen, setThankyouScreen] = useState<React.ReactElement>();

	const value = useMemo(
		() => ({
			loading,
			error,
			errorLog,
			success,
			thankyouScreen,
			setAppLoading: setLoading,
			setAppError: setError,
			setAppErrorLog: setErrorLog,
			setAppSuccess: setSuccess,
			setAppThankyouScreen: setThankyouScreen,
		}),
		[loading, error, errorLog, success, thankyouScreen],
	);

	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => {
	const context = useContext(AppContext);
	if (!context) throw new Error('useApp must be used within AppProvider');
	return context;
};
